import {BaseApi} from '@/core/api/base.api'
import { userService } from '@/core/service/user.service'

class UserApi extends BaseApi {
    constructor() {
        super()
    }

    async changeProfileImage(data) {
        return await userService.changeProfileImage(data);
    }

    async getUploadProfileImageSasUrl() {
        return await userService.getUploadProfileImageSasUrl()
    }
}

export const userApi = new UserApi();